import { sessionStorage as ss } from '@netlify/app-auth'
import { colorFacetsNeutralLight200 } from '@netlify/netlify-design-tokens'

import DockButton from '~/components/DockButton'
import Flex from '~/components/Flex'
import Image from '~/components/Image'
import Tool from '~/components/Tool'
import ToolGroup from '~/components/ToolGroup'
import { useActions, useStore } from '~/store/hooks'
import { messageGift } from '~/utils/messages'

const WIDTH = 264

export default function DockStateLoggedOut() {
  const visibility = useStore(actions => actions.hud.visibility)
  const open = useActions(actions => actions.hud.open)
  const setVisibility = useActions(actions => actions.hud.setVisibility)

  const click = () => {
    messageGift('FULL_VIEWPORT')
    setVisibility('showing')
    open()
    ss.remove('netlify-cdp-dock-minimized')
  }

  return (
    <Flex
      aria-hidden={visibility !== 'minimized'}
      background="tint1"
      borderLeftColor={colorFacetsNeutralLight200}
      borderLeftStyle="solid"
      borderLeftWidth={1}
      borderRightColor={colorFacetsNeutralLight200}
      borderRightStyle="solid"
      borderRightWidth={1}
      borderTopColor={colorFacetsNeutralLight200}
      borderTopLeftRadius={6}
      borderTopRightRadius={6}
      borderTopStyle="solid"
      borderTopWidth={1}
      bottom={0}
      boxShadow="0 0 6px rgba(0, 0, 0, 0.1)"
      className="mini-dock"
      // height={41}
      left={`calc(50% - ${WIDTH / 2}px)`}
      // overflowX="auto"
      position="fixed"
      transform={`translateY(${visibility === 'minimized' ? 0 : 48}px)`}
      transition="transform 300ms ease-in-out"
      width={WIDTH}
      zIndex={2147483646}
    >
      <ToolGroup border="right">
        <Tool
          active={false}
          iconBefore={<Image alt="Logo" height={24} src="/img/logo/netlify.svg" width={24} />}
          label="Deploy Preview"
          // name="drawer"
          onClick={click}
        />
      </ToolGroup>
      <DockButton action="expand" icon="expand" />
      <DockButton action="dismiss" border="left" />
    </Flex>
  )
}
